/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.18.1.0 (NJsonSchema v9.10.66.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { BaseClient } from './BaseClient';

export interface ICustomersClient {
    checkEmailInUse(email: string | null, includeLeads: boolean | undefined, updatingCustomerId: number | null | undefined): Promise<boolean>;
    getMe(): Promise<CustomerDetails | null>;
}

export class CustomersClient extends BaseClient implements ICustomersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    checkEmailInUse(email: string | null, includeLeads: boolean | undefined, updatingCustomerId: number | null | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/customers/checkemail?";
        if (email === undefined)
            throw new Error("The parameter 'email' must be defined.");
        else
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        if (includeLeads === null)
            throw new Error("The parameter 'includeLeads' cannot be null.");
        else if (includeLeads !== undefined)
            url_ += "includeLeads=" + encodeURIComponent("" + includeLeads) + "&"; 
        if (updatingCustomerId !== undefined)
            url_ += "updatingCustomerId=" + encodeURIComponent("" + updatingCustomerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCheckEmailInUse(_response));
        });
    }

    protected processCheckEmailInUse(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    getMe(): Promise<CustomerDetails | null> {
        let url_ = this.baseUrl + "/customers/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetMe(_response));
        });
    }

    protected processGetMe(response: Response): Promise<CustomerDetails | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CustomerDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomerDetails | null>(<any>null);
    }
}

export interface IProductsClient {
    getPublicProducts(): Promise<Product[] | null>;
    getProduct(id: number): Promise<Product | null>;
    /**
     * @deprecated
     */
    getProductByCode(code: string): Promise<Product | null>;
    getActiveProductAddOns(sku: string): Promise<ProductOptionStockAvailability[] | null>;
    getProductBySku(sku: string): Promise<Product | null>;
    getProductOptions(): Promise<ProductOption[] | null>;
    getPublicProductOptions(): Promise<ProductOption[] | null>;
    managedStockIsAvailableForSku(sku: string): Promise<boolean>;
    /**
     * @deprecated
     */
    managedStockIsAvailableForSelectedSkus(multipleSkuRequest: MultipleSkuRequest | null): Promise<ProductOptionStockAvailability[] | null>;
    getProductOptionBySku(sku: string): Promise<ProductOption | null>;
    getBufferStockForWeekAndAddress(weekStarting: Date | null | undefined, addressId: number | null | undefined): Promise<ProductOptionStockAvailability[] | null>;
}

export class ProductsClient extends BaseClient implements IProductsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    getPublicProducts(): Promise<Product[] | null> {
        let url_ = this.baseUrl + "/products";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPublicProducts(_response));
        });
    }

    protected processGetPublicProducts(response: Response): Promise<Product[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Product[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Product[] | null>(<any>null);
    }

    getProduct(id: number): Promise<Product | null> {
        let url_ = this.baseUrl + "/products/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProduct(_response));
        });
    }

    protected processGetProduct(response: Response): Promise<Product | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Product>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Product | null>(<any>null);
    }

    /**
     * @deprecated
     */
    getProductByCode(code: string): Promise<Product | null> {
        let url_ = this.baseUrl + "/products/code/{code}";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProductByCode(_response));
        });
    }

    protected processGetProductByCode(response: Response): Promise<Product | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Product>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Product | null>(<any>null);
    }

    getActiveProductAddOns(sku: string): Promise<ProductOptionStockAvailability[] | null> {
        let url_ = this.baseUrl + "/products/{sku}/addons/active";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetActiveProductAddOns(_response));
        });
    }

    protected processGetActiveProductAddOns(response: Response): Promise<ProductOptionStockAvailability[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductOptionStockAvailability[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductOptionStockAvailability[] | null>(<any>null);
    }

    getProductBySku(sku: string): Promise<Product | null> {
        let url_ = this.baseUrl + "/products/sku/{sku}";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProductBySku(_response));
        });
    }

    protected processGetProductBySku(response: Response): Promise<Product | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Product>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Product | null>(<any>null);
    }

    getProductOptions(): Promise<ProductOption[] | null> {
        let url_ = this.baseUrl + "/products/options";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProductOptions(_response));
        });
    }

    protected processGetProductOptions(response: Response): Promise<ProductOption[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductOption[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductOption[] | null>(<any>null);
    }

    getPublicProductOptions(): Promise<ProductOption[] | null> {
        let url_ = this.baseUrl + "/products/options/public";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPublicProductOptions(_response));
        });
    }

    protected processGetPublicProductOptions(response: Response): Promise<ProductOption[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductOption[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductOption[] | null>(<any>null);
    }

    managedStockIsAvailableForSku(sku: string): Promise<boolean> {
        let url_ = this.baseUrl + "/products/stock/{sku}/available";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processManagedStockIsAvailableForSku(_response));
        });
    }

    protected processManagedStockIsAvailableForSku(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    /**
     * @deprecated
     */
    managedStockIsAvailableForSelectedSkus(multipleSkuRequest: MultipleSkuRequest | null): Promise<ProductOptionStockAvailability[] | null> {
        let url_ = this.baseUrl + "/products/stock/available";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(multipleSkuRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processManagedStockIsAvailableForSelectedSkus(_response));
        });
    }

    protected processManagedStockIsAvailableForSelectedSkus(response: Response): Promise<ProductOptionStockAvailability[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductOptionStockAvailability[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductOptionStockAvailability[] | null>(<any>null);
    }

    getProductOptionBySku(sku: string): Promise<ProductOption | null> {
        let url_ = this.baseUrl + "/products/options/sku/{sku}";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProductOptionBySku(_response));
        });
    }

    protected processGetProductOptionBySku(response: Response): Promise<ProductOption | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductOption>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductOption | null>(<any>null);
    }

    getBufferStockForWeekAndAddress(weekStarting: Date | null | undefined, addressId: number | null | undefined): Promise<ProductOptionStockAvailability[] | null> {
        let url_ = this.baseUrl + "/products/bufferstock/available?";
        if (weekStarting !== undefined)
            url_ += "weekStarting=" + encodeURIComponent(weekStarting ? "" + weekStarting.toJSON() : "") + "&"; 
        if (addressId !== undefined)
            url_ += "addressId=" + encodeURIComponent("" + addressId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBufferStockForWeekAndAddress(_response));
        });
    }

    protected processGetBufferStockForWeekAndAddress(response: Response): Promise<ProductOptionStockAvailability[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductOptionStockAvailability[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductOptionStockAvailability[] | null>(<any>null);
    }
}

export interface IRecipesClient {
    /**
     * @return The image was successfully found
     */
    getRecipeMediaCdnUrl(id: number): Promise<string | null>;
    getRangeOfProductRecipesForWeek(weekStarting: Date | null | undefined, weeksToFetch: number | null | undefined, skuToExclude: string[] | null | undefined): Promise<ProductRecipe[] | null>;
    /**
     * @return The recipe details
     */
    loadRecipeDetails(recipeId: number): Promise<RecipeDetail | null>;
}

export class RecipesClient extends BaseClient implements IRecipesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    /**
     * @return The image was successfully found
     */
    getRecipeMediaCdnUrl(id: number): Promise<string | null> {
        let url_ = this.baseUrl + "/recipes/media/cdn/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRecipeMediaCdnUrl(_response));
        });
    }

    protected processGetRecipeMediaCdnUrl(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(<any>null);
    }

    getRangeOfProductRecipesForWeek(weekStarting: Date | null | undefined, weeksToFetch: number | null | undefined, skuToExclude: string[] | null | undefined): Promise<ProductRecipe[] | null> {
        let url_ = this.baseUrl + "/recipes/productrecipes?";
        if (weekStarting !== undefined)
            url_ += "weekStarting=" + encodeURIComponent(weekStarting ? "" + weekStarting.toJSON() : "") + "&"; 
        if (weeksToFetch !== undefined)
            url_ += "weeksToFetch=" + encodeURIComponent("" + weeksToFetch) + "&"; 
        if (skuToExclude !== undefined)
            skuToExclude && skuToExclude.forEach(item => { url_ += "skuToExclude=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRangeOfProductRecipesForWeek(_response));
        });
    }

    protected processGetRangeOfProductRecipesForWeek(response: Response): Promise<ProductRecipe[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductRecipe[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductRecipe[] | null>(<any>null);
    }

    /**
     * @return The recipe details
     */
    loadRecipeDetails(recipeId: number): Promise<RecipeDetail | null> {
        let url_ = this.baseUrl + "/recipes/detail/{recipeId}";
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadRecipeDetails(_response));
        });
    }

    protected processLoadRecipeDetails(response: Response): Promise<RecipeDetail | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecipeDetail>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeDetail | null>(<any>null);
    }
}

export interface IReferralBenefitClient {
    loadActiveBenefit(code: string | null): Promise<ReferAFriendBenefit | null>;
}

export class ReferralBenefitClient extends BaseClient implements IReferralBenefitClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    loadActiveBenefit(code: string | null): Promise<ReferAFriendBenefit | null> {
        let url_ = this.baseUrl + "/referralbenefit/benefit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(code);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadActiveBenefit(_response));
        });
    }

    protected processLoadActiveBenefit(response: Response): Promise<ReferAFriendBenefit | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ReferAFriendBenefit>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReferAFriendBenefit | null>(<any>null);
    }
}

export interface ISubscriptionsClient {
    /**
     * @param saveToken (optional) 
     * @deprecated
     */
    processPayment(result: string | null, saveToken: boolean | undefined): Promise<boolean>;
    createCustomerAndSubscription(purchaseRequest: PurchaseRequest | null): Promise<CreateSubscriptionResult | null>;
    /**
     * @deprecated
     */
    activateSubscription(result: string | null): Promise<boolean>;
}

export class SubscriptionsClient extends BaseClient implements ISubscriptionsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    /**
     * @param saveToken (optional) 
     * @deprecated
     */
    processPayment(result: string | null, saveToken: boolean | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/subscriptions/payment?";
        if (saveToken === null)
            throw new Error("The parameter 'saveToken' cannot be null.");
        else if (saveToken !== undefined)
            url_ += "saveToken=" + encodeURIComponent("" + saveToken) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(result);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProcessPayment(_response));
        });
    }

    protected processProcessPayment(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }

    createCustomerAndSubscription(purchaseRequest: PurchaseRequest | null): Promise<CreateSubscriptionResult | null> {
        let url_ = this.baseUrl + "/subscriptions/createcustomerandsubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(purchaseRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateCustomerAndSubscription(_response));
        });
    }

    protected processCreateCustomerAndSubscription(response: Response): Promise<CreateSubscriptionResult | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CreateSubscriptionResult>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 409) {
            return response.text().then((_responseText) => {
            let result409: any = null;
            result409 = _responseText === "" ? null : <CreateSubscriptionErrorCode>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result409);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : <CreateSubscriptionErrorCode>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("A server error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateSubscriptionResult | null>(<any>null);
    }

    /**
     * @deprecated
     */
    activateSubscription(result: string | null): Promise<boolean> {
        let url_ = this.baseUrl + "/subscriptions/activateSubscription";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(result);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processActivateSubscription(_response));
        });
    }

    protected processActivateSubscription(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export interface IVouchersClient {
    getVoucher(id: number): Promise<Voucher | null>;
    getVouchersForGroup(id: string): Promise<Voucher[] | null>;
    addVoucher(voucher: SingleVoucher | null): Promise<CreateVoucherResponse | null>;
    addMultipleVouchers(voucherRequest: MultipleVouchersRequest | null): Promise<CreateVoucherResponse | null>;
    processVoucherPayment(result: string | null): Promise<VoucherPaymentResult | null>;
    validate(code: string | null): Promise<VoucherResponse | null>;
    voucherPdf(code: string): Promise<string | null>;
    getAllVoucherPdfs(id: string): Promise<string | null>;
}

export class VouchersClient extends BaseClient implements IVouchersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    getVoucher(id: number): Promise<Voucher | null> {
        let url_ = this.baseUrl + "/vouchers/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetVoucher(_response));
        });
    }

    protected processGetVoucher(response: Response): Promise<Voucher | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Voucher>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Voucher | null>(<any>null);
    }

    getVouchersForGroup(id: string): Promise<Voucher[] | null> {
        let url_ = this.baseUrl + "/vouchers/multiple/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetVouchersForGroup(_response));
        });
    }

    protected processGetVouchersForGroup(response: Response): Promise<Voucher[] | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Voucher[]>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Voucher[] | null>(<any>null);
    }

    addVoucher(voucher: SingleVoucher | null): Promise<CreateVoucherResponse | null> {
        let url_ = this.baseUrl + "/vouchers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(voucher);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddVoucher(_response));
        });
    }

    protected processAddVoucher(response: Response): Promise<CreateVoucherResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CreateVoucherResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateVoucherResponse | null>(<any>null);
    }

    addMultipleVouchers(voucherRequest: MultipleVouchersRequest | null): Promise<CreateVoucherResponse | null> {
        let url_ = this.baseUrl + "/vouchers/multiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(voucherRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddMultipleVouchers(_response));
        });
    }

    protected processAddMultipleVouchers(response: Response): Promise<CreateVoucherResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CreateVoucherResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateVoucherResponse | null>(<any>null);
    }

    processVoucherPayment(result: string | null): Promise<VoucherPaymentResult | null> {
        let url_ = this.baseUrl + "/vouchers/payment?";
        if (result === undefined)
            throw new Error("The parameter 'result' must be defined.");
        else
            url_ += "result=" + encodeURIComponent("" + result) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processProcessVoucherPayment(_response));
        });
    }

    protected processProcessVoucherPayment(response: Response): Promise<VoucherPaymentResult | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <VoucherPaymentResult>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VoucherPaymentResult | null>(<any>null);
    }

    validate(code: string | null): Promise<VoucherResponse | null> {
        let url_ = this.baseUrl + "/vouchers/validate?";
        if (code === undefined)
            throw new Error("The parameter 'code' must be defined.");
        else
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidate(_response));
        });
    }

    protected processValidate(response: Response): Promise<VoucherResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <VoucherResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VoucherResponse | null>(<any>null);
    }

    voucherPdf(code: string): Promise<string | null> {
        let url_ = this.baseUrl + "/vouchers/{code}/voucher";
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processVoucherPdf(_response));
        });
    }

    protected processVoucherPdf(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(<any>null);
    }

    getAllVoucherPdfs(id: string): Promise<string | null> {
        let url_ = this.baseUrl + "/vouchers/multiple/{id}/all";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllVoucherPdfs(_response));
        });
    }

    protected processGetAllVoucherPdfs(response: Response): Promise<string | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <string>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string | null>(<any>null);
    }
}

export interface IFeaturesClient {
    getAllFeatures(): Promise<Features>;
}

export class FeaturesClient extends BaseClient implements IFeaturesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    getAllFeatures(): Promise<Features> {
        let url_ = this.baseUrl + "/features";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllFeatures(_response));
        });
    }

    protected processGetAllFeatures(response: Response): Promise<Features> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <Features>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Features>(<any>null);
    }
}

export interface IDeliveryDateClient {
    /**
     * @param isOneOffBufferSale (optional) 
     * @param excludeBufferDates (optional) 
     * @deprecated
     */
    loadDeliveryDatesForAddress(sku: string, addressId: number, isOneOffBufferSale: boolean | undefined, excludeBufferDates: boolean | undefined): Promise<AvailablePeriod | null>;
}

export class DeliveryDateClient extends BaseClient implements IDeliveryDateClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    /**
     * @param isOneOffBufferSale (optional) 
     * @param excludeBufferDates (optional) 
     * @deprecated
     */
    loadDeliveryDatesForAddress(sku: string, addressId: number, isOneOffBufferSale: boolean | undefined, excludeBufferDates: boolean | undefined): Promise<AvailablePeriod | null> {
        let url_ = this.baseUrl + "/deliverydate/option/{sku}/address/{addressId}?";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku)); 
        if (addressId === undefined || addressId === null)
            throw new Error("The parameter 'addressId' must be defined.");
        url_ = url_.replace("{addressId}", encodeURIComponent("" + addressId)); 
        if (isOneOffBufferSale === null)
            throw new Error("The parameter 'isOneOffBufferSale' cannot be null.");
        else if (isOneOffBufferSale !== undefined)
            url_ += "isOneOffBufferSale=" + encodeURIComponent("" + isOneOffBufferSale) + "&"; 
        if (excludeBufferDates === null)
            throw new Error("The parameter 'excludeBufferDates' cannot be null.");
        else if (excludeBufferDates !== undefined)
            url_ += "excludeBufferDates=" + encodeURIComponent("" + excludeBufferDates) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadDeliveryDatesForAddress(_response));
        });
    }

    protected processLoadDeliveryDatesForAddress(response: Response): Promise<AvailablePeriod | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AvailablePeriod>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AvailablePeriod | null>(<any>null);
    }
}

export interface IPromoClient {
    /**
     * @deprecated
     */
    getOptionPromoInfo(optionPromoRequest: OptionPromoRequest | null): Promise<PromoResponse | null>;
    getPromoCodeDetail(request: PromoDetailRequest | null): Promise<PromoDetailResponse | null>;
    getPromoGroupCodeDetail(request: PromoDetailRequest | null): Promise<PromoGroupDetailResponse | null>;
    /**
     * @deprecated
     */
    isValidToApplyToSubscription(promoCode: string | null, subscriptionId: number): Promise<boolean>;
}

export class PromoClient extends BaseClient implements IPromoClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    /**
     * @deprecated
     */
    getOptionPromoInfo(optionPromoRequest: OptionPromoRequest | null): Promise<PromoResponse | null> {
        let url_ = this.baseUrl + "/promo/bycode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(optionPromoRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetOptionPromoInfo(_response));
        });
    }

    protected processGetOptionPromoInfo(response: Response): Promise<PromoResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PromoResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PromoResponse | null>(<any>null);
    }

    getPromoCodeDetail(request: PromoDetailRequest | null): Promise<PromoDetailResponse | null> {
        let url_ = this.baseUrl + "/promo/detail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPromoCodeDetail(_response));
        });
    }

    protected processGetPromoCodeDetail(response: Response): Promise<PromoDetailResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PromoDetailResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PromoDetailResponse | null>(<any>null);
    }

    getPromoGroupCodeDetail(request: PromoDetailRequest | null): Promise<PromoGroupDetailResponse | null> {
        let url_ = this.baseUrl + "/promo/groupDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetPromoGroupCodeDetail(_response));
        });
    }

    protected processGetPromoGroupCodeDetail(response: Response): Promise<PromoGroupDetailResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PromoGroupDetailResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PromoGroupDetailResponse | null>(<any>null);
    }

    /**
     * @deprecated
     */
    isValidToApplyToSubscription(promoCode: string | null, subscriptionId: number): Promise<boolean> {
        let url_ = this.baseUrl + "/promo/validateforsubscription?";
        if (promoCode === undefined)
            throw new Error("The parameter 'promoCode' must be defined.");
        else
            url_ += "promoCode=" + encodeURIComponent("" + promoCode) + "&"; 
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined and cannot be null.");
        else
            url_ += "subscriptionId=" + encodeURIComponent("" + subscriptionId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processIsValidToApplyToSubscription(_response));
        });
    }

    protected processIsValidToApplyToSubscription(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <boolean>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(<any>null);
    }
}

export interface IUpcomingRecipesClient {
    /**
     * @deprecated
     */
    loadUpcomingProductRecipeBySku(sku: string): Promise<ProductRecipe | null>;
    loadUpcomingReadyMadeMealRecipes(): Promise<RecipeResponse | null>;
    loadUpcomingSelectionRecipesBySku(sku: string): Promise<RecipeResponse | null>;
}

export class UpcomingRecipesClient extends BaseClient implements IUpcomingRecipesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    /**
     * @deprecated
     */
    loadUpcomingProductRecipeBySku(sku: string): Promise<ProductRecipe | null> {
        let url_ = this.baseUrl + "/web/recipes/upcoming/{sku}";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadUpcomingProductRecipeBySku(_response));
        });
    }

    protected processLoadUpcomingProductRecipeBySku(response: Response): Promise<ProductRecipe | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ProductRecipe>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProductRecipe | null>(<any>null);
    }

    loadUpcomingReadyMadeMealRecipes(): Promise<RecipeResponse | null> {
        let url_ = this.baseUrl + "/web/rmm/recipes/upcoming";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadUpcomingReadyMadeMealRecipes(_response));
        });
    }

    protected processLoadUpcomingReadyMadeMealRecipes(response: Response): Promise<RecipeResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecipeResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeResponse | null>(<any>null);
    }

    loadUpcomingSelectionRecipesBySku(sku: string): Promise<RecipeResponse | null> {
        let url_ = this.baseUrl + "/web/selection/recipes/upcoming/{sku}";
        if (sku === undefined || sku === null)
            throw new Error("The parameter 'sku' must be defined.");
        url_ = url_.replace("{sku}", encodeURIComponent("" + sku)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadUpcomingSelectionRecipesBySku(_response));
        });
    }

    protected processLoadUpcomingSelectionRecipesBySku(response: Response): Promise<RecipeResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecipeResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeResponse | null>(<any>null);
    }
}

export interface IRecipeDetailsClient {
    /**
     * @deprecated
     */
    loadRecipeDetailsById(recipeId: number): Promise<RecipeDetailResponse | null>;
    /**
     * Recipes - Legacy load recipe details by RVP. This API is being used on the marketing website (https://www.myfoodbag.co.nz/). Remove this once we moved over to using LoadRecipeDetailsByRVPForWeek.
     * @param recipeId (optional) 
     * @deprecated
     */
    loadRecipeDetailsByRVP(recipeNumber: string, recipeVersion: string, partition: string, recipeId: number | null | undefined): Promise<RecipeDetailResponse | null>;
    /**
     * @param recipeId (optional) 
     * @deprecated
     */
    loadRecipeDetailsByRVPForWeek(recipeNumber: string, recipeVersion: string, partition: string, week: Date, recipeId: number | null | undefined): Promise<RecipeDetailResponse | null>;
}

export class RecipeDetailsClient extends BaseClient implements IRecipeDetailsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl ? baseUrl : "https://";
    }

    /**
     * @deprecated
     */
    loadRecipeDetailsById(recipeId: number): Promise<RecipeDetailResponse | null> {
        let url_ = this.baseUrl + "/web/recipe-details/{recipeId}";
        if (recipeId === undefined || recipeId === null)
            throw new Error("The parameter 'recipeId' must be defined.");
        url_ = url_.replace("{recipeId}", encodeURIComponent("" + recipeId)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadRecipeDetailsById(_response));
        });
    }

    protected processLoadRecipeDetailsById(response: Response): Promise<RecipeDetailResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecipeDetailResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeDetailResponse | null>(<any>null);
    }

    /**
     * Recipes - Legacy load recipe details by RVP. This API is being used on the marketing website (https://www.myfoodbag.co.nz/). Remove this once we moved over to using LoadRecipeDetailsByRVPForWeek.
     * @param recipeId (optional) 
     * @deprecated
     */
    loadRecipeDetailsByRVP(recipeNumber: string, recipeVersion: string, partition: string, recipeId: number | null | undefined): Promise<RecipeDetailResponse | null> {
        let url_ = this.baseUrl + "/web/recipe-details/{recipeNumber}/{recipeVersion}/{partition}?";
        if (recipeNumber === undefined || recipeNumber === null)
            throw new Error("The parameter 'recipeNumber' must be defined.");
        url_ = url_.replace("{recipeNumber}", encodeURIComponent("" + recipeNumber)); 
        if (recipeVersion === undefined || recipeVersion === null)
            throw new Error("The parameter 'recipeVersion' must be defined.");
        url_ = url_.replace("{recipeVersion}", encodeURIComponent("" + recipeVersion)); 
        if (partition === undefined || partition === null)
            throw new Error("The parameter 'partition' must be defined.");
        url_ = url_.replace("{partition}", encodeURIComponent("" + partition)); 
        if (recipeId !== undefined)
            url_ += "recipeId=" + encodeURIComponent("" + recipeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadRecipeDetailsByRVP(_response));
        });
    }

    protected processLoadRecipeDetailsByRVP(response: Response): Promise<RecipeDetailResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecipeDetailResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeDetailResponse | null>(<any>null);
    }

    /**
     * @param recipeId (optional) 
     * @deprecated
     */
    loadRecipeDetailsByRVPForWeek(recipeNumber: string, recipeVersion: string, partition: string, week: Date, recipeId: number | null | undefined): Promise<RecipeDetailResponse | null> {
        let url_ = this.baseUrl + "/web/recipe-details/{recipeNumber}/{recipeVersion}/{partition}/{week}?";
        if (recipeNumber === undefined || recipeNumber === null)
            throw new Error("The parameter 'recipeNumber' must be defined.");
        url_ = url_.replace("{recipeNumber}", encodeURIComponent("" + recipeNumber)); 
        if (recipeVersion === undefined || recipeVersion === null)
            throw new Error("The parameter 'recipeVersion' must be defined.");
        url_ = url_.replace("{recipeVersion}", encodeURIComponent("" + recipeVersion)); 
        if (partition === undefined || partition === null)
            throw new Error("The parameter 'partition' must be defined.");
        url_ = url_.replace("{partition}", encodeURIComponent("" + partition)); 
        if (week === undefined || week === null)
            throw new Error("The parameter 'week' must be defined.");
        url_ = url_.replace("{week}", encodeURIComponent(week ? "" + week.toJSON() : "null")); 
        if (recipeId !== undefined)
            url_ += "recipeId=" + encodeURIComponent("" + recipeId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            headers: {
                "Content-Type": "application/json", 
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processLoadRecipeDetailsByRVPForWeek(_response));
        });
    }

    protected processLoadRecipeDetailsByRVPForWeek(response: Response): Promise<RecipeDetailResponse | null> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RecipeDetailResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecipeDetailResponse | null>(<any>null);
    }
}

export interface CustomerDetails {
    AddressId: number;
    PafId?: number | undefined;
    Address?: string | undefined;
    DeliveryInstructions?: string | undefined;
    FirstName?: string | undefined;
    LastName?: string | undefined;
    MobileNumber?: string | undefined;
    Email?: string | undefined;
    CustomerNumber?: string | undefined;
    CreditCards?: CardDetails[] | undefined;
}

export interface CardDetails {
    CardId: number;
    CardNumber?: string | undefined;
    CardHolderName?: string | undefined;
    CardType?: string | undefined;
    ExpiryDate?: string | undefined;
    IsDefault: boolean;
}

export interface Product {
    ProductId: number;
    Name?: string | undefined;
    ProductCode?: string | undefined;
    Description?: string | undefined;
    ProductType: ProductType;
    Active: boolean;
    Options?: ProductOption[] | undefined;
    DateCreated: Date;
    LastUpdated: Date;
    HasStockAvailable: boolean;
}

export enum ProductType {
    Primary = 1, 
    Extra = 2, 
    Donation = 3, 
    OneOff = 4, 
    Service = 5, 
    Promotional = 6, 
}

export interface ProductOption {
    OptionId: number;
    ProductId: number;
    Sku?: string | undefined;
    ItemNumber?: string | undefined;
    Name?: string | undefined;
    ProductName?: string | undefined;
    ProductType: ProductType;
    Price: number;
    DeliveryPrice: number;
    Active: boolean;
    ShowInAccount: boolean;
    ShowInDeliveryExport: boolean;
    DateCreated: Date;
    LastUpdated: Date;
    WebSortOrder: number;
    HasUnlimitedBufferStock: boolean;
    QuantityPerLine: number;
    SelectionPoolCount: number;
    RequiredSelectionCount: number;
    EndDate?: Date | undefined;
    Brand: Brand;
    AvailableFrequency: AvailableFrequency;
    NumberOfPeopleToFeed: number;
    RecipeSelectionMode: RecipeSelectionMode;
    ImageUrl?: string | undefined;
    NumberOfNights: number;
}

export enum Brand {
    MyFoodBag = 1, 
    BargainBox = 2, 
    FreshStart = 4, 
    ReadyMadeMeals = 8, 
}

export enum AvailableFrequency {
    Weekly = 1, 
    Fortnightly = 2, 
    OneOff = 4, 
    FourWeekly = 8, 
}

export enum RecipeSelectionMode {
    None = 0, 
    Single = 1, 
    Multiple = 2, 
}

export interface ProductOptionStockAvailability {
    Sku?: string | undefined;
    HasStockAvailable: boolean;
    NumberOfPeopleToFeed?: number | undefined;
}

export interface MultipleSkuRequest {
    Skus?: string[] | undefined;
}

export interface ProductRecipe {
    ProductDetails?: RecipeProductDetail | undefined;
    Sku?: string | undefined;
    RecipeCollection?: RecipeGrouping[] | undefined;
    OptionName?: string | undefined;
    NumberOfPeopleToFeed: number;
    IsLateSalesDisabled: boolean;
}

export interface RecipeProductDetail {
    ProductShortName?: string | undefined;
    ProductName?: string | undefined;
    PageLink?: string | undefined;
    CssClass?: string | undefined;
    PerWeek: number;
    HasMultipleVariants: boolean;
}

export interface RecipeGrouping {
    DeliveryDate: Date;
    DeliveryDateDescription?: string | undefined;
    Recipes?: RecipeSliderInfo[] | undefined;
}

export interface RecipeSliderInfo {
    RecipeName?: string | undefined;
    ImageUrl?: string | undefined;
    Energy?: number | undefined;
    RecipeId: number;
    RecipeNumber?: string | undefined;
    RecipeVersion?: string | undefined;
    RecipePartition?: string | undefined;
    Calories: number;
    IsDefaultChoice: boolean;
    UnitSurcharge?: number | undefined;
}

export interface RecipeDetail {
    Name?: string | undefined;
    Description?: string | undefined;
    CdnImage?: string | undefined;
    ReadyIn?: number | undefined;
    CelebrityChef?: string | undefined;
    ProductDetail?: RecipeProductDetail | undefined;
    WeekStarting: Date;
    Energy?: number | undefined;
    Carbohydrate?: number | undefined;
    Fat?: number | undefined;
    Protein?: number | undefined;
    IngredientGroups?: RecipeIngredientGroup[] | undefined;
    Steps?: RecipeStep[] | undefined;
    NumberOfServes?: string | undefined;
    CookingEffort?: string | undefined;
    HasNutritionalInfo: boolean;
    RequiresLegend: boolean;
    RecipeUrl?: string | undefined;
    Calories: number;
}

export interface RecipeIngredientGroup {
    RecipeIngredientGroupId: number;
    RecipeId: number;
    Name?: string | undefined;
    DateAdded: Date;
    LastUpdated: Date;
    Ingredients?: RecipeIngredient[] | undefined;
    SubRecipes?: SubRecipe[] | undefined;
}

export interface RecipeIngredient {
    RecipeIngredientId: number;
    RecipeIngredientGroupId: number;
    Quantity?: string | undefined;
    Unit?: string | undefined;
    Ingredient?: string | undefined;
    IsStaple: boolean;
    IsShared: boolean;
    SortOrder: number;
    DateAdded: Date;
    LastUpdated: Date;
}

export interface SubRecipe {
    SubRecipeId: number;
    Name?: string | undefined;
    Description?: string | undefined;
    DateCreated: Date;
}

export interface RecipeStep {
    RecipeStepId: number;
    RecipeId: number;
    RecipeMediaId?: number | undefined;
    StepNumber?: string | undefined;
    SortOrder: number;
    StepDetails?: string | undefined;
    DateAdded: Date;
    LastUpdated: Date;
    ManualIngredient?: string | undefined;
}

export interface ReferAFriendBenefit {
    ReferAFriendBenefitId: number;
    StartDate: Date;
    CreatedOn: Date;
    ModifiedOn: Date;
    EndDate?: Date | undefined;
    AmountOff: number;
    FriendPercentOff: number;
    ReferrerDollarOff: number;
    FriendPromoGroupCode?: string | undefined;
    IsPromoGroupRaf: boolean;
    IsLegacy: boolean;
}

export interface PurchaseRequest {
    CreateSubscription?: CreateSubscription | undefined;
    Lead?: LeadDto | undefined;
    SuccessUrl?: string | undefined;
    FailUrl?: string | undefined;
    PurchaseSuccessPage?: string | undefined;
    ShouldUseDefaultCreditCard: boolean;
}

export interface CreateSubscription {
    SubscriptionNumber?: string | undefined;
    ProductOptionId: number;
    DeliveryDateId: number;
    AddressId?: number | undefined;
    Frequency: Frequency;
    PromoGroupId?: number | undefined;
    CustomerReferralCode?: string | undefined;
    ReferralId?: number | undefined;
    OverallTotal: number;
    VoucherId?: number | undefined;
    CartId: string;
    CampaignCode?: string | undefined;
    OverrideDeliverySlotId?: number | undefined;
    DeliveryInstructions?: string | undefined;
}

export enum Frequency {
    Weekly = 1, 
    Fortnightly = 2, 
    OneOff = 3, 
    FourWeekly = 4, 
}

export interface LeadDto {
    Email?: string | undefined;
    FirstName?: string | undefined;
    LastName?: string | undefined;
    PasswordSalt?: string | undefined;
    PrimaryProductSku?: string | undefined;
    PasswordHash?: string | undefined;
    AddressId: number;
    MobileNumber?: string | undefined;
    LeadSource: LeadSource;
    DeliveryInstructions?: string | undefined;
    CustomerNumber?: string | undefined;
}

export enum LeadSource {
    Mfb = 0, 
    Bb = 1, 
    Admin = 2, 
    Marketing = 3, 
    Orderform = 4, 
    Outgrow = 5, 
    Blog = 6, 
    Unbounce = 7, 
    InvolveMe = 8, 
    Shop = 9, 
    Business = 10, 
    Signup = 11, 
}

export interface CreateSubscriptionResult {
    ResultType: CreateSubscriptionResultType;
    SubscriptionPaymentSuccess?: SubscriptionPaymentSuccess | undefined;
    SubscriptionPaymentFailure?: SubscriptionPaymentFailure | undefined;
    SubscriptionPaymentRedirect?: SubscriptionPaymentRedirect | undefined;
    SubscriptionNumber?: string | undefined;
    FirstDeliveryWeek?: Date | undefined;
    IsPurchasingBuffer: boolean;
    DeliveryId?: number | undefined;
}

export enum CreateSubscriptionResultType {
    Success = 0, 
    Failure = 1, 
    Redirect = 2, 
}

export interface SubscriptionPaymentSuccess {
    Subscription?: Subscription | undefined;
}

export interface Subscription {
    SubscriptionId: number;
    SubscriptionNumber?: string | undefined;
    Customer?: Customer | undefined;
    DeliverySlot?: DeliverySlot | undefined;
    PrimaryProductOption?: ProductOption | undefined;
    Frequency: Frequency;
    Status: SubscriptionStatus;
    FirstDelivery: Date;
    LastDelivery?: Date | undefined;
    LastDeliveryDateId?: number | undefined;
    CancellationReason?: string | undefined;
    CancellationComments?: string | undefined;
    CancellationDate?: Date | undefined;
    DateCreated: Date;
    LastUpdated: Date;
    AddOns?: SubscriptionAddOn[] | undefined;
    WouldConsiderReturning?: boolean | undefined;
}

export interface Customer {
    CustomerId: number;
    CustomerNumber?: string | undefined;
    FirstName?: string | undefined;
    LastName?: string | undefined;
    Email?: string | undefined;
    Password?: string | undefined;
    ReferAFriendCode?: string | undefined;
    Address?: Address | undefined;
    MobileNumber?: string | undefined;
    DeliveryInstructions?: string | undefined;
    DPSToken?: string | undefined;
    Balance: number;
    Status: CustomerStatus;
    DateCreated: Date;
    LastUpdated: Date;
    VIP: boolean;
    FirstDeliveryDate?: Date | undefined;
    HasHadDeliveries: boolean;
    PerpetualDiscount?: number | undefined;
    PerpetualDiscountType?: PerpetualDiscountType | undefined;
    CustomerType: CustomerType;
    LeadSource: LeadSource;
    FullName?: string | undefined;
    IsNew: boolean;
}

export interface Address {
    AddressId: number;
    PafId?: number | undefined;
    Dpid?: number | undefined;
    Street?: string | undefined;
    RDNumber?: string | undefined;
    Suburb?: string | undefined;
    City?: string | undefined;
    Postcode?: string | undefined;
    State?: string | undefined;
    SuburbId?: number | undefined;
    Longitude?: number | undefined;
    Latitude?: number | undefined;
    ValidArea?: ValidArea | undefined;
}

export interface ValidArea {
    ValidAreaId: number;
    PostCode?: string | undefined;
    Suburb?: string | undefined;
    DeliveryArea?: DeliveryArea | undefined;
    ValidAreaAddresses?: ValidAreaAddress[] | undefined;
}

export interface DeliveryArea {
    DeliveryAreaId: number;
    Name?: string | undefined;
    Price: number;
    DepotId?: number | undefined;
    Code?: string | undefined;
}

export interface ValidAreaAddress {
    PafId: number;
    ValidAreaId: number;
}

export enum CustomerStatus {
    Lead = 1, 
    Active = 3, 
    Inactive = 5, 
    Disabled = 6, 
}

export enum PerpetualDiscountType {
    Percentage = 0, 
    Value = 1, 
}

export enum CustomerType {
    Standard = 0, 
    MFBStaff = 1, 
    MFBContractor = 2, 
    Influencer = 3, 
    Director = 4, 
    PrizeWinner = 5, 
    ThirdPartyCompany = 6, 
    ProductReview = 7, 
    Corporate = 8, 
    B2B = 9, 
}

export interface DeliverySlot {
    DeliverySlotId: number;
    Description?: string | undefined;
    DeliveryDay: DayOfWeek;
    TimeRangeStart: string;
    TimeRangeEnd: string;
    SortOrder: number;
}

export enum DayOfWeek {
    Sunday = 0, 
    Monday = 1, 
    Tuesday = 2, 
    Wednesday = 3, 
    Thursday = 4, 
    Friday = 5, 
    Saturday = 6, 
}

export enum SubscriptionStatus {
    Active = 1, 
    Paused = 2, 
    Cancelling = 3, 
    Cancelled = 4, 
    Pending = 5, 
}

export interface SubscriptionAddOn {
    SubscriptionAddOnId: number;
    SubscriptionId: number;
    Product?: Product | undefined;
    Option?: ProductOption | undefined;
    Frequency: Frequency;
    Quantity: number;
    DateAdded: Date;
    LastModified: Date;
}

export interface SubscriptionPaymentFailure {
    PaymentResponse?: string | undefined;
}

export interface SubscriptionPaymentRedirect {
    RedirectUrl?: string | undefined;
}

export enum CreateSubscriptionErrorCode {
    LeadAlreadyExists = 10001, 
    BufferHasBeenConsumed = 20001, 
    VoucherHasBeenConsumed = 30001, 
}

export interface Voucher {
    VoucherGroup: string;
    VoucherCode?: string | undefined;
    VoucherDate: Date;
    RedeemableUntil: Date;
    SuggestedProductOption?: ProductOption | undefined;
    PurchaserCustomerId?: number | undefined;
    PurchaserFirstName?: string | undefined;
    PurchaserLastName?: string | undefined;
    PurchaserEmail?: string | undefined;
    PurchaserPhone?: string | undefined;
    PurchaserCompany?: string | undefined;
    RecipientFirstName?: string | undefined;
    RecipientLastName?: string | undefined;
    RecipientEmail?: string | undefined;
    RecipientPhone?: string | undefined;
    VoucherAmount: number;
    RedemptionDate?: Date | undefined;
    RedemptionCustomerId?: number | undefined;
    RedemptionCustomerNumber?: string | undefined;
    RedemptionCustomerName?: string | undefined;
    RedemptionCustomerEmail?: string | undefined;
    PaymentTransactionReference?: string | undefined;
    Paid: boolean;
    Active: boolean;
    Reserved: boolean;
    Redeemed: boolean;
    Message?: string | undefined;
    ChristmasGift?: VoucherChristmasGift | undefined;
    CanBeRedeemed: boolean;
}

export interface VoucherChristmasGift {
    AddressId: number;
    FullAddress?: string | undefined;
    DeliverToPurchaser: boolean;
    DeliveryCost: number;
    GiftName?: string | undefined;
}

export interface SingleVoucher extends Voucher {
    RedirectUrl?: string | undefined;
}

export interface CreateVoucherResponse {
    ResponseType: CreateVoucherResponseType;
    Success: boolean;
    Response?: string | undefined;
    PaymentRedirectUrl?: string | undefined;
    MultipleVouchersId: string;
    SingleVoucherId: number;
}

export enum CreateVoucherResponseType {
    PaymentSuccess = 0, 
    PaymentFailure = 1, 
    NoPayment = 2, 
    Redirect = 3, 
}

export interface MultipleVouchersRequest {
    SpecifiedGroupId?: string | undefined;
    Quantity: number;
    SuggestedProductOption?: ProductOption | undefined;
    PurchaserCustomerId?: number | undefined;
    PurchaserFirstName?: string | undefined;
    PurchaserLastName?: string | undefined;
    PurchaserEmail?: string | undefined;
    PurchaserPhone?: string | undefined;
    PurchaserCompany?: string | undefined;
    VoucherAmount: number;
    RedirectUrl?: string | undefined;
    Message?: string | undefined;
}

export interface VoucherPaymentResult {
    IsSuccess: boolean;
    Response?: string | undefined;
    VoucherGroupId?: string | undefined;
}

export interface VoucherResponse {
    VoucherCode?: string | undefined;
    VoucherId: number;
    VoucherAmount: number;
}

export interface Features {
    CanUnskipDemandLockedDeliveries: boolean;
    DisableRestartSubscription: boolean;
    UseNewBilling: boolean;
    DisplayUxOptinBanner: boolean;
    ObeyDemandLocks: boolean;
    EnableChoiceBufferInWebAndOrderForm: boolean;
    EnableBufferInAccount: boolean;
    EnableSkipPreventionFlexDown: boolean;
    EnableFlexUp: boolean;
    EnableFlexDown: boolean;
    EnableCustomerAddressHoliday: boolean;
    EnablePlanYourWeekInOrderForm: boolean;
    UsePriceBook: boolean;
    OverrideLegacyReactivationFlow: boolean;
    OverrideLegacyCancelSubscriptionFlow: boolean;
    DashboardV2: boolean;
    UseShippingSalePrice: boolean;
    DisableLegacyRecipeBufferStock: boolean;
    SendPartialPayments: boolean;
    TestSystemFeature: boolean;
    TestUserFeature1: boolean;
    TestUserFeature2: boolean;
}

export interface AvailablePeriod {
    RegularSlots?: AvailableDeliverySlot[] | undefined;
    AvailableDates?: AvailableDeliveryDate[] | undefined;
    UpcomingDeliveryWeek: Date;
}

export interface AvailableDeliverySlot {
    Day: DayOfWeek;
    StartTime: string;
    EndTime: string;
    DeliverySlotId: number;
    Description?: string | undefined;
}

export interface AvailableDeliveryDate {
    EndTime: string;
    StartTime: string;
    DeliveryDateId: number;
    Date: Date;
    DeliverySlotType: DeliverySlotType;
    DeliverySlotId: number;
    WeekStarting: Date;
    IsBufferWeek: boolean;
    Description?: string | undefined;
}

export enum DeliverySlotType {
    Standard = 0, 
    LateSale = 1, 
}

export interface OptionPromoRequest {
    Code?: string | undefined;
    OptionId: number;
}

export interface PromoResponse {
    PromoCode?: string | undefined;
    PromoId: number;
}

export interface PromoDetailRequest {
    Code?: string | undefined;
    CustomerNumber?: string | undefined;
    ProductSkus?: string[] | undefined;
}

export interface PromoDetailResponse {
    Description?: string | undefined;
    PromoValue: number;
    PromoType?: string | undefined;
    PromoId: number;
    PromoCode?: string | undefined;
    FreeProduct?: string | undefined;
    RedeemableTo: Date;
    RedeemableFrom: Date;
    Restrictions?: string[] | undefined;
}

export interface PromoGroupDetailResponse {
    Description?: string | undefined;
    PromoGroupId: number;
    PromoGroupCode?: string | undefined;
    Promos?: PromoDetailResponse[] | undefined;
    Restrictions?: string[] | undefined;
}

export interface RecipeResponse {
    ProductName?: string | undefined;
    DeliveryWeek: Date;
    Recipes?: GridRecipe[] | undefined;
    DeliveryDateDescription?: string | undefined;
}

export interface GridRecipe {
    Name?: string | undefined;
    Description?: string | undefined;
    ImageUrl?: string | undefined;
    RecipeCategoryId: number;
    Quantity: number;
    Protein?: number | undefined;
    Sodium?: number | undefined;
    CarbohydrateSugar?: number | undefined;
    Carbohydrate?: number | undefined;
    SaturatedFat?: number | undefined;
    Fat?: number | undefined;
    Energy?: number | undefined;
    Ingredients?: string | undefined;
    Allergens?: string | undefined;
    CookTime?: number | undefined;
    NumberOfServes?: string | undefined;
    RecipeId?: number | undefined;
    RecipeNumber?: string | undefined;
    RecipeVersion?: string | undefined;
    RecipePartition?: string | undefined;
    RecipeGroupRecipeId: string;
    SortOrder: number;
    RecipeBadgeNames?: string[] | undefined;
    RecipeTagNames?: string[] | undefined;
}

export interface RecipeDetailResponse {
    Name?: string | undefined;
    Description?: string | undefined;
    NumberOfServes?: string | undefined;
    ReadyInTime?: string | undefined;
    Badges?: string[] | undefined;
    Tags?: string[] | undefined;
    ImageUrl?: string | undefined;
    IngredientGroups?: IngredientGroup[] | undefined;
    Legends?: string[] | undefined;
    NutritionalInfo?: string[] | undefined;
    Steps?: RecipeStep2[] | undefined;
    Allergens?: string | undefined;
    Disclaimer?: string | undefined;
    UnitSurcharge?: number | undefined;
}

export interface IngredientGroup {
    Name?: string | undefined;
    Ingredients?: string[] | undefined;
}

export interface RecipeStep2 {
    Header?: string | undefined;
    Detail?: string | undefined;
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new SwaggerException(message, status, response, headers, result);
}

export type Day = string;

export type Week = string;

// This is used to attach the import by default
// on the core client
export default BaseClient;